// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"59d7f958","315":"719aff14","453":"726a9731","501":"329f1030","513":"e1a9bc37","692":"f359d3e2"}[chunkId] + ".chunk.js";
};